import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const toastOptions = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 3,
  newestOnTop: true,
  position: 'top-right',
  timeout: 5000,
  hideProgressBar: false,
  draggable: true,
  draggablePercent: 0.6,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
};

export { Toast, toastOptions };
